'use client';

/**
 * SysObeyaKpiProductivityCard — productivity KPI tile.
 *
 * Slices `response.totals.{total_saved_hours, total_gain_pct}` from
 * the system_obeya_view composite. Chrome (label, unit) comes from
 * `response.labels`. One of four tiles that replace the legacy
 * monolithic SysObeyaKpiStripCard.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_productivity"
 * @see klyde_edge/ui_config/labels/system_obeya.py — mod_sum_kpi_productivity_*
 */

import { Clock } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiProductivityCard({ view_name = 'module_summary' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  const pct = t.total_gain_pct;
  const subValue = typeof pct === 'number' ? pct.toLocaleString() : '—';
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_productivity"
      label={L.mod_sum_kpi_productivity_label ?? ''}
      Icon={Clock}
      value={isLoading ? '…' : fmt(t.total_saved_hours)}
      sub={`${subValue}${L.mod_sum_kpi_productivity_unit ?? ''}`.trim()}
      queryKey={queryKey}
    />
  );
}
